import base from './base';
import axios from '@/utils/request'
const api = {
    login(params){
        return axios.post(base.login,params)
    },
    getWeChatUrl(params){
        return axios.post(base.getWeChatUrl,params)
    },
    islogin(params){
        return axios.post(base.islogin,params)
    },
    repwd(params){
        return axios.post(base.repwd,params)
    },
    //全新机批发
    sortBrandnewList(params){
        return axios.post(base.sortBrandnewList,params)
    },
    addBrandnewSort(params){
        return axios.post(base.addBrandnewSort,params)
    },
    deleBrandnewSort(params){
        return axios.post(base.deleBrandnewSort,params)
    },
    allsortBrandnewList(params){
        return axios.post(base.allsortBrandnewList,params)
    },
    modelBrandnewList(params){
        return axios.post(base.modelBrandnewList,params)
    },
    addBrandnewModel(params){
        return axios.post(base.addBrandnewModel,params)
    },
    deleBrandnewModel(params){
        return axios.post(base.deleBrandnewModel,params)
    },

    outbrandnewExcel(params){
        return axios.post(base.outbrandnewExcel,params)
    },
    inbrandnewExcel(params){
        return axios.post(base.inbrandnewExcel,params)
    },
    Bncollection(params){
        return axios.post(base.Bncollection,params)
    },


    //物料管理
    getSupplierinfo(params){
        return axios.post(base.getSupplierinfo,params)
    },
    material(params){
        return axios.post(base.material,params)
    },
    hswiper(params){
        return axios.post(base.hswiper,params)
    },

    colorList(params){
        return axios.post(base.colorList,params)
    },
    addColor(params){
        return axios.post(base.addColor,params)
    },
    editColor(params){
        return axios.post(base.editColor,params)
    },
    deleColor(params){
        return axios.post(base.deleColor,params)
    },

    memoryList(params){
        return axios.post(base.memoryList,params)
    },
    addMemory(params){
        return axios.post(base.addMemory,params)
    },
    editMemory(params){
        return axios.post(base.editMemory,params)
    },
    deleMemory(params){
        return axios.post(base.deleMemory,params)
    },
    
    // 汇付支付
    edithuifu(params){
        return axios.post(base.edithuifu,params)
    },

    //快递管理
    expressList(params){
        return axios.post(base.expressList,params)
    },
    editExpress(params){
        return axios.post(base.editExpress,params)
    },
    deleExpress(params){
        return axios.post(base.deleExpress,params)
    },
};

export default api;